<template>
    <div>
        <v-card>
            <system-configuration-tabs current-tab="ManageBlockedEmailDomains" />
            <v-toolbar flat color="white" class="mt-4">
                <v-toolbar-title>Manage Blocked Email Domains</v-toolbar-title>
                <v-spacer />
                <search-filter v-model="keywordSearch" />
                <v-btn color="secondary" dark @click="dialogDomain = true">
                    Add
                </v-btn>
            </v-toolbar>
            <v-data-table :headers="headers"
                          :items="blockedEmailDomains"
                          :pagination.sync="pagination"
                          :total-items="totalRecords"
                          :loading="loading"
                          :rows-per-page-items="rowsPerPageItems">
                <v-progress-linear slot="progress" color="secondary" indeterminate />
                <template slot="items" slot-scope="props">
                    <td>{{ props.item.domain }}</td>
                    <td class="text-xs-right">
                        <v-icon small class="mr-2" @click="editEmailDomain(props.item)">
                            edit
                        </v-icon>
                    </td>
                    <td class="text-xs-right">
                        <v-icon @click="deleteEmailDomain(props.item)">
                            far fa-trash-alt
                        </v-icon>
                    </td>
                </template>
            </v-data-table>
        </v-card>

        <v-dialog v-model="dialogDomain" width="500">
            <v-card>
                <alert-banner :msg="alertMessage" />
                <form @submit.prevent="saveEmailDomain">
                    <v-card-title class="headline lighten-2" primary-title>
                        {{ editItem.id ? 'Edit' : 'Add' }} Email Domain
                    </v-card-title>
                    <v-container fill-height fluid>
                        <v-layout wrap justify-center>
                            <v-flex xs11>
                                <v-text-field v-model="editItem.domain" label="Domain" required />
                            </v-flex>
                        </v-layout>
                    </v-container>
                    <v-card-actions>
                        <v-spacer />
                        <v-btn color="danger" flat @click.native="close">
                            cancel
                        </v-btn>
                        <v-btn color="primary" flat type="submit" :loading="saving">
                            save
                        </v-btn>
                    </v-card-actions>
                </form>
            </v-card>
        </v-dialog>
    </div>
</template>


<script>
    import _ from 'lodash';
    import localforage from 'localforage';
    import axios from 'axios';
    import SystemConfigurationTabs from './components/SystemConfigurationTabs.vue';

    export default {
        parent: true,

        components: {
            SystemConfigurationTabs,
        },

        props: {
            isAdmin: {
                type: Boolean,
                default: false,
            },
        },

        data: () => ({
            loading: true,
            blockedEmailDomains: [],
            dialogDomain: false,
            saving: false,
            defaultItem: {
                domain: ''
            },
            editItem: {
                domain: '',
            },
            totalRecords: 0,
            rowsPerPageItems: [20, 50, 75, 100],
            pagination: {
                descending: false,
                page: 1,
                rowsPerPage: 20,
                sortBy: 'domain',
                totalItems: 0,
            },
            headers: [
                {
                    text: 'Domain', value: 'domain', align: 'left', sortable: true,
                },
                { text: 'Edit', align: 'right', sortable: false },
                { text: 'Delete', align: 'right', sortable: false },
            ],
            keywordSearch: '',
            addDialog: false,
        }),

        watch: {
            pagination: {
                handler(newval, oldval) {
                    console.log(`Old value: ${oldval}`);
                    console.log(`New value: ${newVal}`);
                    if (!_.isEqual(newval, oldval)) {
                        this.getBlockedEmailDomains();
                    }
                },
                deep: true,
            },

            'pagination.rowsPerPage': function (val) {
                localforage.setItem('ManageBlockedEmailDomains:RowsPerPage', val);
            },

            keywordSearch() {
                this.processSearch();
            },
        },

        mounted() {
            localforage.getItem('ManageBlockedEmailDomains:RowsPerPage').then((value) => {
                this.pagination.rowsPerPage = value || 20;
                this.getBlockedEmailDomains();
            });
        },

        methods: {
            async getBlockedEmailDomains() {
                const { sortBy, descending, page, rowsPerPage, } = this.pagination;
                const sortDirection = descending
                    ? `${sortBy} DESC`
                    : `${sortBy} ASC`;

                this.loading = true;
                const { data } = await axios.get('/api/blocked-email-domains', {
                    params: {
                        currentPage: page,
                        pageSize: rowsPerPage,
                        sortDir: sortDirection,
                        filter: this.keywordSearch
                    }
                });

                console.log(data);

                this.blockedEmailDomains = data.resultItems;
                this.totalRecords = data.totalRecords;
                this.loading = false;
            },

            async saveEmailDomain() {
                this.saving = true;
                if (this.editItem.id) {
                    await axios.patch(`/api/blocked-email-domains/${this.editItem.id}`, this.editItem)
                        .then(() => {
                            this.getBlockedEmailDomains();
                            this.close();
                        })
                        .catch((error) => {
                            this.processErrors(error, this.editItem);
                        })
                        .then(() => {
                            this.saving = false;
                        });
                } else {
                    await axios.post('/api/blocked-email-domains/', this.editItem)
                        .then(() => {
                            this.getBlockedEmailDomains();
                            this.close();
                        })
                        .catch((error) => {
                            this.processErrors(error, this.editItem);
                        })
                        .then(() => {
                            this.saving = false;
                        });
                }
            },


            async deleteEmailDomain(emailDomain) {
                const result = confirm('Are you sure you want to delete this item?'); // eslint-disable-line
                if (result) {
                    await axios.delete(`/api/blocked-email-domains/${emailDomain.id}`);
                    await this.getBlockedEmailDomains();
                }
            },


            editEmailDomain(item) {
                this.editItem = item;
                this.dialogDomain = true;
            },


            close() {
                this.dialogDomain = false;
                this.clearErrors();
                setTimeout(() => {
                    this.editItem = Object.assign({}, this.defaultItem);
                }, 300);
            },


            processSearch: _.debounce(function () {
                this.getBlockedEmailDomains();
            }, 600),
        },
    };
</script>